<template>
    <Form class="dpm" v-bind="$attrs" v-on="$listeners">
        <div class="flex">
            <FormItem prop="pledge">
                <Select v-model="info.pledge" style="width: 100px">
                    <Option v-for="v in pledgeList" :value="v" :key="v">{{
                        v
                    }}</Option>
                </Select>
            </FormItem>
            <div class="dpm-txt">付</div>
            <FormItem prop="pay">
                <Select v-model="info.pay" style="width: 100px">
                    <Option v-for="v in payList" :value="v" :key="v">{{
                        v
                    }}</Option>
                </Select>
            </FormItem>
        </div>
    </Form>
</template>

<script>
export default {
    name: 'demo-pay-method',
    inheritAttrs: false,
    data() {
        return {
            info: {
                pledge: '',
                pay: '',
            },
            pledgeList: ['押0', '押1', '押2', '押3'],
            payList: ['1', '2', '3', '4', '6', '12'],
        }
    },
}
</script>

<style lang="less">
.dpm {
    &-txt {
        padding: 0 10px;
    }
}
</style>
